import * as React from "react";

// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

// store, state

import { constants, detailUrl } from "../../../store/componentTypes";

export default function ComponentTypesTable({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
  detailUrlMethod,
}) {
  const columns = React.useMemo(() => columnDefs(), [persistantQuery]);

  const redirectMethod =
    detailUrlMethod || ((obj) => detailUrl({ id: obj.id }));

  const badges = {};
  const filters = {};

  return (
    <>
      <BaseTable
        tableId={tableId || "errand_component_types_full_table"}
        title={"Komponenter"}
        onRowClickedWithDetail={(obj) => redirectMethod(obj)}
        {...{
          isBare,
          ignoreLocalStorage,
          onRowClicked,
          columns,
          persistantQuery,
          badges,
          filters,
          constants,
          checkRowHighlighted,
          onRowSelected,
        }}
      />
    </>
  );
}
